import { useState, useEffect } from "react"
import { Progress } from "@/components/ui/progress"

interface TimedProgressBarProps {
	/**
	 * The total duration for the progress bar to complete, in milliseconds.
	 */
	duration: number
	/**
	 * An optional callback function that is called when the progress bar completes.
	 */
	onComplete?: () => void
}

export const TimedProgressBar = ({
	duration,
	onComplete,
}: TimedProgressBarProps) => {
	const [progress, setProgress] = useState(0)

	useEffect(() => {
		setProgress(0)
		const intervalTime = 50 // Update progress every 50ms
		const totalSteps = duration / intervalTime
		const increment = 100 / totalSteps

		const interval = setInterval(() => {
			setProgress((prev) => {
				if (prev >= 100) {
					clearInterval(interval)
					if (onComplete) {
						onComplete()
					}
					return 100
				}
				return prev + increment
			})
		}, intervalTime)

		return () => clearInterval(interval)
	}, [duration, onComplete])

	return <Progress value={progress} />
}
